<template>
  <v-flex xl4 md7 sm9 xs13>
    <page-toolbar>
      <kendo-button icon="add" title="Add" v-show="editable" @click="addNew"> </kendo-button>
    </page-toolbar>
    <kendo-grid
      height="calc(100vh - 165px)"
      :dataSource="dataSource"
      :detailInit="createDetailGrid"
      :editable="editable && 'inline'"
      ref="grid"
      :filterable="false"
      :sortable="true"
      :pageable-always-visible="false"
      :columns="columns"
      @detailcollapse="gridCollapse"
    >
    </kendo-grid>
  </v-flex>
</template>
<script>
import axios from 'axios'
import PageToolbar from '@/components/PageToolbar'
import {mapGetters} from 'vuex'
import {datePickerEditor, numericEditor} from '@/helpers/kendo-editors'
import {getDataItem} from '@/helpers/kendo-helpers'
const $ = kendo.jQuery

export default {
  mounted() {
    this.getData()
  },
  data() {
    return {
      gridData: [],
      gridColumns: [],
      defaultInitialDate: null,
      restrictedDates: [],
    }
  },
  methods: {
    addNew() {
      const grid = this.$refs.grid.kendoWidget()
      grid.addRow()
    },
    getGridColumns(columns, isDetail) {
      const editable = this.editable
      const allColumns = []

      if (!isDetail)
        allColumns.push({
          command: [
            {
              name: 'edit',
              visible: dataItem => dataItem.isNew(),
            },
          ],
          title: '&nbsp;',
          width: 60,
        })

      allColumns.push({
        field: 'EvaluationDate',
        title: isDetail ? 'Evaluation Date' : 'Period Date',
        lockable: false,
        hidden: false,
        width: isDetail ? 82 : 100,
        sortable: true,
        headerAttributes: {Class: 'ResetRateHeader'},
        attributes: {Class: 'evaluationDate'},
        format: isDetail ? '{0:yyyy-MM-dd}' : '{0:MMM-yyyy}',
        editor: datePickerEditor(
          {
            start: 'year',
            depth: 'year',
            format: 'MMM-yyyy',
            dates: this.restrictedDates,
            disableDates: date => {
              if (date && this.compareDates(date, this.restrictedDates)) {
                return true
              } else {
                return false
              }
            },
          },
          true,
        ),
      })
      columns.forEach(function(column) {
        allColumns.push({
          field: column,
          title: column,
          width: 82,
          headerAttributes: {
            Class: 'ResetRateHeader',
            style: 'text-align: center; font-size: 14px;',
          },
          attributes: {style: 'text-align: right;'},
          sortable: false,
          template: function(e) {
            const value = e[column] || 0
            if (editable) {
              return "<span style='cursor:cell;'>" + kendo.toString(value, 'n5') + '</span>'
            } else {
              return '<span ' + kendo.toString(value, 'n5') + '</span>'
            }
          },
          editor: isDetail
            ? numericEditor({decimals: 14, format: 'n5', spinners: false, step: 0})
            : ' ',
        })
      })

      if (isDetail) return allColumns

      allColumns.push({
        command: {
          name: 'exportDetail',
          iconClass: 'k-icon k-i-excel',
          click: (e => {
            const dataItem = getDataItem($(e.target).closest('tr'))
            const exportUrl =
              '/api/heroux/ResetCcyRate/exportDetailToExcel' +
              '?evaluationDate=' +
              kendo.toString(dataItem.EvaluationDate, 'yyyy-MM-dd')
            window.location.href = exportUrl + `&t=${this.tokenString}`
          }).bind(this),
        },
        title: 'Export Detail',
        width: 60,
        headerAttributes: {Class: 'ResetRateHeader'},
        attributes: {style: 'text-align: center;'},
      })

      allColumns.push({
        field: 'CanBeDeleted',
        title: '&nbsp;',
        width: 60,
        filterable: false,
        sortable: false,
        attributes: {style: 'text-align: center;'},
        template:
          "# if(CanBeDeleted) { # <a class='k-button k-button-icontext k-grid-delete'><span class='k-icon k-i-delete'></span>Delete</a> # } #",
        hidden: !editable,
      })

      return allColumns
    },
    getDynamicFields(columns, isDetail) {
      let editable = this.editable
      let fields = {
        ResetRateId: {type: 'number', defaultValue: 0},
        EvaluationDate: {
          editable: !isDetail,
          type: 'date',
          defaultValue: () => this.defaultInitialDate,
        },
      }
      columns.forEach(function(column) {
        fields[column] = {field: column, editable: editable, defaultValue: 0}
      })

      if (isDetail) return fields

      fields['CanBeDeleted'] = {type: 'bool', defaultValue: true, editable: false}

      return fields
    },
    getUpdateItems(data, columns) {
      let validColumns = columns.filter(function(column) {
        return column.indexOf('EvaluationDate') < 0
      })

      let evaluationDate = kendo.toString(data['EvaluationDate'], 'yyyy-MM-dd')
      let resetRateId = data['ResetRateId']
      let resetRateItems = []

      validColumns.forEach(function(column) {
        let newDataItem = {
          resetRateCode: column,
          value: data[column],
        }
        resetRateItems.push(newDataItem)
      })

      let dataItem = {
        ResetRateId: resetRateId,
        EvaluationDate: evaluationDate,
        ResetRateItems: resetRateItems,
        CanBeDeleted: data['CanBeDeleted'],
      }
      return dataItem
    },
    compareDates(date, dates) {
      for (let i = 0; i < dates.length; i++) {
        let tmpDate = kendo.parseDate(dates[i])
        if (tmpDate.getMonth() === date.getMonth() && tmpDate.getYear() === date.getYear()) {
          return true
        }
      }
      return false
    },
    getUpdateBatchItems(data, columns) {
      const validColumns = columns.filter(function(column) {
        return column.indexOf('EvaluationDate') < 0
      })

      const dataItems = []
      data.forEach(function(model) {
        const evaluationDate = kendo.toString(model['EvaluationDate'], 'yyyy-MM-dd')
        const resetRateId = model['ResetRateId']
        const resetRateItems = []

        validColumns.forEach(function(column) {
          const newDataItem = {
            ResetRateCode: column,
            value: model[column],
          }
          resetRateItems.push(newDataItem)
        })

        const dataItem = {
          ResetRateId: resetRateId,
          EvaluationDate: evaluationDate,
          ResetRateItems: resetRateItems,
        }

        dataItems.push(dataItem)
      })

      return dataItems
    },
    async createDetailGrid(expandElement) {
      const editable = this.editable
      const result = await axios.get('/api/heroux/ResetCcyRate/detailDataSource', {
        params: {
          evaluationDate: expandElement.data.EvaluationDate,
        },
      })
      const response = result.data
      const columns = response.columns

      const dataSource = {
        transport: {
          read: function(options) {
            options.success(response)
          },
          update: async options => {
            const createUrl = '/api/heroux/ResetCcyRate/updateDetail'
            const dataItems = this.getUpdateBatchItems(options.data.models, columns)
            const {data} = await axios.put(createUrl, {dataItems})
            options.success(data)
          },
        },
        batch: true,
        schema: {
          data: 'data',
          errors: 'errors',
          total: 'total',
          model: {
            id: 'ResetRateId',
            fields: this.getDynamicFields(columns, true, editable),
          },
        },
      }

      const grid = $(
        "<div style='width: 96%;' id='detail_" +
          expandElement.data.DivisionId +
          "' class='k-content' />",
      )
        .appendTo(expandElement.detailCell)
        .empty()
        .kendoGrid({
          navigatable: true,
          dataSource: dataSource,
          editable: editable && 'incell',
          hidden: false,
          resizable: true,
          reorderable: true,
          sortable: true,
          toolbar: editable ? ['save', 'cancel'] : [],
          columns: this.getGridColumns(columns, true, editable),
        })
        .data('kendoGrid')

      if (!editable) {
        grid.element.find('.k-grid-toolbar').hide()
      }
    },
    getDataSource(gridData) {
      return new kendo.data.DataSource({
        transport: {
          read: options => {
            options.success({data: gridData})
          },
          create: options => {
            const createUrl = '/api/heroux/ResetCcyRate'
            const dataItem = this.getUpdateItems(options.data, this.gridColumns)
            this.restrictedDates.push(this.defaultInitialDate)
            axios.post(createUrl, dataItem).then(({data}) => {
              this.defaultInitialDate = kendo.toString(data.defaultInitialDate, 'yyyy-MM-dd')

              const newItem = data.data
              options.data.ResetRateId = newItem.ResetRateId
              options.success({data: [options.data]})
            })
          },
          destroy: async options => {
            const destroyUrl = '/api/heroux/ResetCcyRate'
            const date = kendo.toString(options.data['EvaluationDate'], 'yyyy-MM-dd')
            const {data} = await axios.delete(destroyUrl, {params: {evaluationDate: date}})
            this.defaultInitialDate = data.defaultInitialDate
            this.removeDateFromRestricted(date)
            options.success(data.data)
          },
        },
        schema: {
          data: 'data',
          errors: 'errors',
          total: 'total',
          model: {
            id: 'ResetRateId',
            fields: this.getDynamicFields(this.gridColumns, false),
          },
        },
      })
    },
    removeDateFromRestricted(date) {
      let resDates = this.restrictedDates.filter(function(resDate) {
        return resDate.slice(0, 10) != kendo.toString(date, 'yyyy-MM-dd')
      })
      this.restrictedDates = resDates
    },
    async getData() {
      const {data} = await axios.get('/api/heroux/ResetCcyRate')
      this.restrictedDates = data.dates
      this.gridColumns = data.columns
      this.defaultInitialDate = data.defaultInitialDate
      this.gridData = data.data
    },
    gridCollapse() {
      this.getData()
    },
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    ...mapGetters({role: 'authentication/currentRole'}),
    ...mapGetters({tokenString: 'authentication/tokenString'}),
    editable() {
      return this.role != 'Guest'
    },
    columns() {
      return this.getGridColumns(this.gridColumns, false)
    },
    dataSource() {
      return this.getDataSource(this.gridData)
    },
  },
  components: {
    PageToolbar,
  },
}
</script>
